/**
 * Gera um ID numérico para uma pendência a partir do ID do documento do Firebase.
 * A função utiliza um algoritmo de hash simples para converter a string alfanumérica do ID
 * em um número. O resultado é um número de 8 dígitos, preenchido com zeros à esquerda se necessário.
 *
 * @param {string} docId - O ID do documento do Firebase.
 * @returns {string} Um ID numérico de 8 dígitos.
 */
export const generatePendencyId = (docId) => {
    if (!docId) return '';

    let hash = 0;
    for (let i = 0; i < docId.length; i++) {
        const char = docId.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Converte para um inteiro de 32 bits
    }

    const numericId = Math.abs(hash);

    // Formata para ter 8 dígitos, preenchendo com zeros à esquerda
    return numericId.toString().slice(0, 8).padStart(8, '0');
};
